export default __webpack_public_path__ + "static/media/united-states.a4482e8d.svg";